module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-infiniti.885468e6.jpg";